import { Icon } from "@iconify/react/dist/iconify.js";
import "datatables.net-dt/js/dataTables.dataTables.js";
import $ from "jquery";
import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import {
  custom_open_close_reviews,
  server_post_data,
} from "../ServiceConnection/serviceconnection";
import { handleError } from "../CommonJquery/CommonJquery";

const TableDataLayer = ({ data }) => {
  const tableRef = useRef(null);
  const dataTableRef = useRef(null);

  useEffect(() => {
    // Initialize DataTable
    const initializeDataTable = () => {
      if (data && data.length > 0) {
        // Destroy existing DataTable if it exists
        if (dataTableRef.current) {
          dataTableRef.current.destroy();
          dataTableRef.current = null;
        }

        // Initialize new DataTable
        dataTableRef.current = $(tableRef.current).DataTable({
          destroy: true,
          pageLength: 10,
          retrieve: true,
          responsive: true,
          // Prevent DataTables from adding its own classes which might conflict
          autoWidth: false,
          ordering: true,
          searching: true,
        });
      }
    };

    // Call initialization
    initializeDataTable();

    // Cleanup function
    return () => {
      if (dataTableRef.current) {
        dataTableRef.current.destroy();
        dataTableRef.current = null;
      }
    };
  }, [data]); // Only re-run if data changes

  const formatReviewDate = (entryDate) => {
    const today = new Date();
    const reviewDate = new Date(entryDate);

    const todayStart = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );
    const reviewStart = new Date(
      reviewDate.getFullYear(),
      reviewDate.getMonth(),
      reviewDate.getDate()
    );

    const diffInDays = Math.floor(
      (todayStart - reviewStart) / (1000 * 60 * 60 * 24)
    );

    if (diffInDays === 0) {
      const hours = reviewDate.getHours().toString().padStart(2, "0");
      const minutes = reviewDate.getMinutes().toString().padStart(2, "0");
      return `${hours}:${minutes}`;
    } else if (diffInDays === 1) {
      return "Yesterday";
    } else {
      const isDifferentYear = today.getFullYear() !== reviewDate.getFullYear();
      const options = isDifferentYear
        ? { day: "numeric", month: "short", year: "numeric" }
        : { day: "numeric", month: "short" };
      return reviewDate.toLocaleDateString("en-US", options);
    }
  };

  const master_update_open = async (id) => {
    let fd_from = new FormData();
    fd_from.append("ticket_id", id);
    try {
      const response = await server_post_data(
        custom_open_close_reviews,
        fd_from
      );
      const data1 = response.message.split("~@~");
      if (parseInt(data1[0]) === 1) {
        handleError(data1[1]);
      }
    } catch (error) {
      console.error("Error in master_update_open:", error);
    }
  };

  return (
    <div className="card basic-data-table">
      <div className="card-header">
        <h5 className="card-title mb-0">Snapshots</h5>
      </div>
      <div className="card-body" style={{ width: "100%", overflowX: "scroll" }}>
        <table
          ref={tableRef}
          className="table bordered-table mb-0"
          id="dataTable"
        >
          <thead>
            <tr>
              <th scope="col">
                <div className="form-check style-check d-flex align-items-center">
                  <label className="form-check-label">SR.</label>
                </div>
              </th>
              <th scope="col">Channel</th>
              <th scope="col">Name</th>
              <th scope="col">Review</th>
              <th scope="col">Rating</th>
              <th scope="col">Date</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            {data.map((review, index) => (
              <tr
                key={review.bb_id}
                onClick={() => master_update_open(review.bb_id)}
              >
                <td>
                  <Link
                    to="/Reviews"
                    state={{ review_id: review.bb_id }}
                    className="w-100"
                  >
                    <div className="form-check style-check d-flex align-items-center">
                      <label className="form-check-label">{index + 1}</label>
                    </div>
                  </Link>
                </td>
                <td>
                  <Link
                    to="/Reviews"
                    state={{ review_id: review.bb_id }}
                    className="text-primary-600 w-100"
                  >
                    {review.platform}
                  </Link>
                </td>
                <td>
                  <Link
                    to="/Reviews"
                    state={{ review_id: review.bb_id }}
                    className="w-100"
                  >
                    {review.name_user}
                  </Link>
                </td>
                <td>
                  <Link
                    to="/Reviews"
                    state={{ review_id: review.bb_id }}
                    className="w-100"
                  >
                    <div className="d-flex align-items-center">
                      <h6
                        className="text-md mb-0 fw-medium flex-grow-1"
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "100px",
                        }}
                      >
                        {review.msg}
                      </h6>
                    </div>
                  </Link>
                </td>
                <td>
                  <Link
                    to="/Reviews"
                    state={{ review_id: review.bb_id }}
                    className="w-100"
                  >
                    {review.rating}
                  </Link>
                </td>
                <td>
                  <Link
                    to="/Reviews"
                    state={{ review_id: review.bb_id }}
                    className="w-100"
                  >
                    {formatReviewDate(review.entry_date)}
                  </Link>
                </td>
                <td>
                  <Link
                    to="/Reviews"
                    state={{ review_id: review.bb_id }}
                    className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                  >
                    <Icon icon="lucide:edit" />
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableDataLayer;
